import { render, staticRenderFns } from "./tabeladocard--datatable.vue?vue&type=template&id=1d3fd142"
import script from "./tabeladocard--datatable.vue?vue&type=script&lang=js"
export * from "./tabeladocard--datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports